<!--
  - Copyright (c) 2020.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div style="text-align: center;">
        <van-loading type="spinner" v-show="loading" />
            <div>
                <pdf
                    v-for="i in numPages"
                    :key="i"
                    :src="src"
                    :page="i"
                    style=""></pdf>
            </div>
    </div>
</template>

<script>
    //see https://github.com/FranckFreiburger/vue-pdf
    import pdf from 'vue-pdf';
    import PinchZoom from 'vue-pinch-zoom';

    export default {
        name: "PdfViewer",
        components: {
            pdf, PinchZoom
        },
        props: {
            url: String
        },
        data() {
            return {
                loading: true,
                page: 1,
                numPages: 0,
                errors: [],

                src: this.$props.url ? pdf.createLoadingTask({
                    url: this.$props.url,
                    withCredentials: true,
                    httpHeaders: {
                        'X-Token': localStorage.getItem("token")
                    }
                }) : null

                // src: {
                //     url: this.src,
                //     httpHeaders: { 'X-Token': localStorage.getItem("token") }
                // }
            }
        },
        created() {
            if (this.numPages === 0) {
                // this.$Spin.show();
            }
        },
        mounted() {
            if (this.src) {
                this.src.promise.then(pdf => {
                    this.loading = false;
                    this.numPages = pdf.numPages;
                    // this.$refs["myPinch"].toggleZoom();
                });
            } else {
                this.loading = false;
                // this.$Spin.hide();
            }
        },
        watch: {},
        methods: {}
    }
</script>

<style lang="css" scoped>
</style>